export interface SkinConfig {
  id: string;
  name: string;
  bodyColor: number;
  cheekColor: number;
  noseColor: number;
  accessory?: 'hat' | 'glasses' | 'scarf' | 'crown' | 'helmet';
  accessoryColor?: number;
  price: number; // 0 = free (default)
}

export const SKINS: SkinConfig[] = [
  {
    id: 'default',
    name: 'Классический',
    bodyColor: 0xffcc66,
    cheekColor: 0xffaaaa,
    noseColor: 0xff9999,
    price: 0,
  },
  {
    id: 'golden',
    name: 'Золотой',
    bodyColor: 0xffd700,
    cheekColor: 0xffee88,
    noseColor: 0xffaa00,
    accessory: 'crown',
    accessoryColor: 0xffd700,
    price: 100,
  },
  {
    id: 'hacker',
    name: 'Хакер',
    bodyColor: 0x333333,
    cheekColor: 0x44ff44,
    noseColor: 0x222222,
    accessory: 'glasses',
    accessoryColor: 0x00ff00,
    price: 150,
  },
];

export function getSkin(id: string): SkinConfig {
  return SKINS.find((s) => s.id === id) ?? SKINS[0]!;
}

export function getUnlockedSkins(): string[] {
  try {
    const data = localStorage.getItem('hamsters_skins');
    return data ? JSON.parse(data) : ['default'];
  } catch {
    return ['default'];
  }
}

export function unlockSkin(id: string): void {
  const skins = getUnlockedSkins();
  if (!skins.includes(id)) {
    skins.push(id);
    localStorage.setItem('hamsters_skins', JSON.stringify(skins));
  }
}

export function equipSkin(id: string): void {
  localStorage.setItem('hamsters_equipped_skin', id);
}

export function getEquippedSkin(): string {
  return localStorage.getItem('hamsters_equipped_skin') ?? 'default';
}
